import React from 'react'
import { PriceInputs } from '@/components/PriceInputs'

interface IProps {
  onInputPricesChange: ({ key, value }: { key: string; value: number }) => void
  prices: {
    priceFrom?: number
    priceTo?: number
  }
}
export const PriceMainFilters = ({ onInputPricesChange, prices }: IProps) => {
  return (
    <div className="flex flex-col gap-4 p-4 rounded-xl border border-surface-strokes shadow-[0px_3px_34px_-2px_rgba(34,34,34,0.20)] bg-white ">
      <PriceInputs onInputPricesChange={onInputPricesChange} prices={prices} />
    </div>
  )
}
